import {combineReducers} from 'redux';

import league from './support/league';
import leagueCalendar from './support/league/calendar';
import leagueRanking from './support/league/ranking';
import user from './support/user';
import userMailPush from './support/user/mailPush';
import userAlerts from './support/user/alerts';
import tournament from './support/tournament';

export default combineReducers({
  league,
  leagueCalendar,
  leagueRanking,
  user,
  userMailPush,
  userAlerts,
  tournament,
});



// WEBPACK FOOTER //
// ./src/reducers/app/support.js